import { useMemo } from "react";
import { TotalOrdersPanelProps } from "./TotalOrdersPanel.types";
import { isToday } from "date-fns";
import { useRefreshRegister } from "../../components/RefreshProvider";
import { usePostTotalOrdersQuery } from "../../app/useGeneratedApi";
import { getLastPeriod } from "../../utils/dateUtils";

export function useTotalOrdersPanel(props: TotalOrdersPanelProps) {
  const { from, to } = props;

  const {
    data: totalOrdersData,
    refetch,
    isLoading: isLoadingStatistics,
    error,
  } = usePostTotalOrdersQuery({
    from,
    to,
  });

  useRefreshRegister(async () => {
    await refetch();
  });

  const statistics = useMemo(() => {
    return totalOrdersData;
  }, [totalOrdersData]);

  return {
    statistics,
    isLoadingStatistics,
    error,
    lastPeriod: isToday(to || new Date())
      ? getLastPeriod(statistics?.compareDays || 0)
      : "period",
  };
}
